<template>
  <div :class="getClasses()">
    <label
      v-if="label"
      :for="id"
      :title="$t(help)"
      :style="{color: fieldTextColor}"
      :class="['c-cbr-FormField-label', {'error': hasError }]">

      {{ $t(label) }}

      <span
        v-if="hasError"
        class="c-cbr-FormField-error"
      >{{ errorMessage }}</span>

      <span
        v-if="help"
        class="c-cbr-FormField-tooltip"
        @click="toggleInfoBox()">i</span>

    </label>
    <div
      v-if="isMobile() && helpInfoClicked"
      :class="['c-cbr-FormField-label']"
      style="margin-bottom: 5px"
    >{{ `${$t('form.email_help')}` }}</div>

    <input
      v-if="type === 'text'"
      :class="['c-cbr-FormField-input', {'is-error': hasError }]"
      :id="id"
      :name="id"
      :value="value"
      :autocomplete="autofill"
      type="text"
      @input="input($event.target.value)"
      @blur="blur($event.target.value)">

    <input
      v-else-if="type === 'email'"
      :class="['c-cbr-FormField-input', {'is-error': hasError }]"
      :id="id"
      :name="id"
      :value="value"
      :autocomplete="autofill"
      :placeholder="$t('form.email_optional')"
      type="text"
      @input="input($event.target.value)"
      @blur="blur($event.target.value)">

    <div
      v-else-if="type === 'select'"
      class="c-cbr-FormField-select-wrapper">
      <select
        :class="['c-cbr-FormField-input', {'is-error': hasError }]"
        :id="id"
        :name="id"
        :value="value"
        :autocomplete="autofill"
        @change="input($event.target.value); blur($event.target.value)"
        @blur="blur($event.target.value)">
        <option
          v-for="(v, k) in options"
          :key="k"
          :value="k">{{ v }}</option>
      </select>
    </div>

    <div
      v-else-if="type === 'select-reason'"
      class="c-cbr-FormField-select-wrapper">
      <select
        :class="['c-cbr-FormField-input', {'is-error': hasError }]"
        :id="id"
        :name="id"
        :autocomplete="autofill"
        @change="blur($event.target.value); separateKeyValue($event.target.value);"
        @blur="blur($event.target.value)">
        <option
          value="none"
          selected
          disabled
          hidden/>
        <option
          v-for="(v) in options_array"
          :key="v"
          :value="v+ ' : '+$t('returnReason.'+v)">{{ $t('returnReason.'+v) }}</option>
      </select>
    </div>

    <input
      v-if="isOtherReason"
      :id="id"
      :class="['c-cbr-FormField-input', {'is-error': hasError }]"
      :placeholder="$t('form.optional_return_reason')"
      type="text"
      @input="input($event.target.value)"
    >
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  model: {
    value: 'value',
    event: 'input'
  },

  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    },
    autofill: {
      type: String,
      required: false,
      default: undefined
    },
    scope: {
      type: String,
      required: true
    },
    help: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => ({})
    },
    classes: {
      type: Array,
      default: () => []
    },
    options_array: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      internal: '',
      helpInfoClicked: false,
      isOtherReason: ''
    }
  },

  computed: {
     ...mapState('inputData', ['formData',]),
    ...mapGetters('config', ['fieldTextColor']),
    vvId() {
      return `${this.scope}.${this.id}`
    }
  },

  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },

    toggleInfoBox() {
      this.helpInfoClicked = !this.helpInfoClicked;
    },

    getToolTip(help) {
      return help;
    },

    input(value) {
      this.$emit('input', value)
    },

    blur(value) {
      this.$emit('blur', value)
    },

    getClasses() {
      return ['c-cbr-FormField-col'].concat(this.classes)
    },

     separateKeyValue(val){
      const keyValue = val.split(' : ')
       const key= keyValue[0].replace(/^([A-Z])|[\s-_]+(\w)/g, function(match, p1, p2) {
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();
      });

           key === 'otherReason'
        ? (this.isOtherReason = true)
        : (this.isOtherReason = false)


      this.formData.return_reason_key= key;
      this.$emit('input', keyValue[1])
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/CbrFormField.vue